import { CASE_STUDIES_BY_SLUG } from "../common/caseStudies";
import { DEFAULT_PAGE_META, PAGE_META, type PageMeta } from "../common/PAGE_META";
import { resolveRedirectPath } from "../common/redirects";
import { getOctantProductMeta } from "./services/octant/octantPageService";
import events from "./data/events.json";
import { blogMeta } from "./pages/Blog/utils";

// TODO: manage the blog meta collection types better OR redefine RouteString

export function getDocumentMetadata(url: string): PageMeta {
  const resolvedUrl = resolveRedirectPath(url);

  const routeMeta = PAGE_META[resolvedUrl];
  if (routeMeta) {
    return routeMeta;
  }

  if (resolvedUrl.startsWith("/blog/")) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (blogMeta[resolvedUrl]) {
      return blogMeta[resolvedUrl];
    }
  }

  if (resolvedUrl.startsWith("/events/")) {
    const eventSlug = resolvedUrl.split("/")[2];
    const eventData = events.find((evt) => evt.id === eventSlug);

    if (eventData) {
      return {
        title: `MyDecisive | ${eventData.title}`,
        description: eventData.subtext,
      };
    }
  }

  if (resolvedUrl.startsWith("/case-study/")) {
    const caseStudySlug = resolvedUrl.split("/")[2];
    const caseStudyData = caseStudySlug
      ? CASE_STUDIES_BY_SLUG[caseStudySlug]
      : undefined;

    if (caseStudyData) {
      return {
        title: `MyDecisive | ${caseStudyData.title}`,
        description: caseStudyData.description,
      };
    }
  }

  if (resolvedUrl.startsWith("/octant/")) {
    const octantSlug = resolvedUrl.split("/")[2];
    const octantMeta = getOctantProductMeta(octantSlug);

    if (octantMeta) {
      return octantMeta;
    }
  }

  return DEFAULT_PAGE_META;
}
